import React, { Component } from 'react';
import { serverIp, firebaseAuth, logComponentLoad, } from '../../../../config/constants.js'
import { Table, Header } from 'semantic-ui-react'
import * as UiConsts from '../../../../config/UiConstants'
import axios from 'axios'
import { getPrintValues, checkAdminEmail } from '../../../dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils';

class ViewMessageLogs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            order: '',
            loadingUser: true,
            loading: false,

            messageEvents: [],
        }
    }

    componentDidMount() {
        firebaseAuth().onAuthStateChanged((user) => {

            if (user) {
                console.log("maddx241 user is:" + user.email);

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult);

                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    loading: false,
                    user: user,
                    uid: user.uid
                })
            }
        });

    }

    setAdminResult = (returnObject) => {
        // console.log("++++++ addx294 setAdminResult");
        // console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "ViewMessageLogs");

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
            loadingUser: false
        })

        if (returnObject.isAdmin) {

            this.loadMessageLogs(this.props.match.params.messageId);

        }
    }

    loadMessageLogs = () => {
        // SEND CHECK TO SERVER

        this.setState({
            loadingUser: true
        })

        let liveServer = "https://printbaws.com/PrintBReporting/webresources/redis/getRedisKey/MSG_EVNTS_" + this.props.match.params.messageId + "/list";
        let localUrl  = "http://localhost:8080/PrintBReporting/webresources/redis/getRedisKey/MSG_EVNTS_" + this.props.match.params.messageId + "/list";

        let url = "";

        if(this.props.match.params.server == 'local'){
            url = localUrl;
        }else{
            url = liveServer;
        }

        console.log("url:" + url);

        axios.get(url)
            .then((response) => {
                console.log("entx221 response:" + JSON.stringify(response.data, null, 3));

                if (response.data.messageEvents && response.data.messageEvents.length > 0) {
                    console.log('got message events');
                    this.setState({
                        messageEvents: response.data.messageEvents
                    })
                }else{
                    alert("no message logs found for:"+this.props.match.params.messageId);
                }

                this.setState({
                    loadingUser: false
                })

            })
            .catch((error) => {
                console.log(error);
                this.setState({ loading: false })
            });
    }

    render() {


        const tableRow = this.state.messageEvents.length > 0
            ? this.state.messageEvents.map((item, index) =>
                <Table.Row>
                    <Table.Cell textAlign='left'>
                        <Header as='h3' textAlign='center'>
                            {index+1}
                        </Header>
                    </Table.Cell>
                    <Table.Cell textAlign='left'>
                        <Header as='h4' textAlign='center'>
                            {item.event}
                        </Header>
                    </Table.Cell>
                    <Table.Cell> {item.methodName} </Table.Cell>
                    
                    <Table.Cell singleLine>{item.timeString}</Table.Cell>
                    <Table.Cell>{item.time_long}</Table.Cell>
                </Table.Row>)
            : ''

        const wholeUI = this.state.algoliaUser && this.state.algoliaUser.isAdmin
            ? <div>

                <Table celled>
                    <Table.Header>
                        <Table.Row>
                        <Table.HeaderCell>#</Table.HeaderCell>
                        <Table.HeaderCell>event</Table.HeaderCell>
                            <Table.HeaderCell>methodName</Table.HeaderCell>
                            <Table.HeaderCell>timeString</Table.HeaderCell>
                            <Table.HeaderCell>time_long</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {tableRow}
                    </Table.Body>

                </Table>

            </div>
            : <h4>loading error a75</h4>

        return (this.state.loadingUser === true ? <UiConsts.LoadingComponent /> :
            <div>

                {wholeUI}

            </div>
        )
    }
}

export default ViewMessageLogs;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Whatsapp/ViewMessageLogs.js